import { render, staticRenderFns } from "./AddText.vue?vue&type=template&id=6687d2b8&"
import script from "./AddText.vue?vue&type=script&lang=js&"
export * from "./AddText.vue?vue&type=script&lang=js&"
import style0 from "./AddText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports